// import { Grid } from '@material-ui/core';
import { Button, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { toast } from 'react-toastify';
import service from '../../apis/service';
import Theme from '../ui/Theme';
import useAsync from '../common/hooks/useAsync';
import { apiEndpoints } from '../../constants/apiEndpoints';

toast.configure();

const useStyles = makeStyles(() => ({
  otpBtn: {
    width: '200px',
    height: '42px',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
}));

const ApiMigrations = () => {
  const classes = useStyles();

  const { isFetching: isLoadingUpdateJourneyIndex, run: runUpdateJourneyIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_JOURNEY_INDEX),
    {
      showSuccessMessage: 'Migration Es Journey Update Successful',
    },
  );
  const { isFetching: isLoadingUpdateTagIndex, run: runUpdateTagIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_TAG_INDEX),
    {
      showSuccessMessage: 'Migration Es Tag Update Successful',
    },
  );

  const { isFetching: isLoadingUpdateGuideIndex, run: runUpdateGuideIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_GUIDE_INDEX),
    {
      showSuccessMessage: 'Migration Es Guide Update Successful',
    },
  );

  const { isFetching: isLoadingUpdateStoryIndex, run: runUpdateStoryIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_STORY_INDEX),
    {
      showSuccessMessage: 'Migration Es Story Update Successful',
    },
  );

  const { isFetching: isLoadingUpdateGuideViewAndAverageCount, run: runUpdateGuideViewAndAverageCount } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_GUIDE_VIEW_AVERAGE_COUNT),
    {
      showSuccessMessage: 'Migration Guide View And Average Count Successful',
    },
  );

  const { isFetching: isLoadingUpdateAiExercise, run: runUpdateAiExercise } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_AI_EXERCISE),
    {
      showSuccessMessage: 'Migration AI Exercise Update Index Successful',
    },
  );

  const { isFetching: isLoadingUpdateOrganizationsIndex, run: runUpdateOrganizationsIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_ORGANIZATIONS_INDEX),
    {
      showSuccessMessage: 'Migration Organizations Update Index Successful',
    },
  );

  const { isFetching: isLoadingUpdateStateIndex, run: runUpdateStateIndex } = useAsync(
    () => service.get(apiEndpoints.DEV_UPDATE_STATE_INDEX),
    {
      showSuccessMessage: 'Migration State Update Index Successful',
    },
  );

  return (
    <Grid>
      <br />
      <Grid item>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography id="modal-modal-title" variant="h5" component="h2" alignItems="center">
            Api Migrations
          </Typography>
        </Grid>
      </Grid>
      <br />
      <br />
      <Grid item>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateJourneyIndex}
              disabled={isLoadingUpdateJourneyIndex}
            >
              ES Update Journey Index
            </Button>
            &nbsp;
            {isLoadingUpdateJourneyIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateGuideIndex}
              disabled={isLoadingUpdateGuideIndex}
            >
              ES Update Guide Index
            </Button>
            &nbsp;
            {isLoadingUpdateGuideIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateStoryIndex}
              disabled={isLoadingUpdateStoryIndex}
            >
              ES Update Story Index
            </Button>
            &nbsp;
            {isLoadingUpdateStoryIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />

          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateTagIndex}
              disabled={isLoadingUpdateTagIndex}
            >
              ES Update Tag Index
            </Button>
            &nbsp;
            {isLoadingUpdateTagIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateGuideViewAndAverageCount}
              disabled={isLoadingUpdateGuideViewAndAverageCount}
            >
              Update Guide View and Rating Count
            </Button>
            &nbsp;
            {isLoadingUpdateGuideViewAndAverageCount ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateAiExercise}
              disabled={isLoadingUpdateAiExercise}
            >
              ES Update AI Exercise Index
            </Button>
            &nbsp;
            {isLoadingUpdateAiExercise ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateOrganizationsIndex}
              disabled={isLoadingUpdateOrganizationsIndex}
            >
              ES Update Organizations Index
            </Button>
            &nbsp;
            {isLoadingUpdateOrganizationsIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>

          <br />
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Button
              className={classes.otpBtn}
              variant="outlined"
              onClick={runUpdateStateIndex}
              disabled={isLoadingUpdateStateIndex}
            >
              ES Update State Index
            </Button>
            &nbsp;
            {isLoadingUpdateStateIndex ? <CircularProgress color="inherit" /> : null}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ApiMigrations;
